import axios from 'axios'
import {ApiConfig as config} from '@/config'

function parseReviews (response) {
  return response.data.reviews.map(review => {
    review.createdAt = new Date(review.createdAt)
    review.adminAnswerAt = review.adminAnswerAt ? new Date(review.adminAnswerAt) : null
    return review
  })
}

function getReviewsAverrage (response) {
  var reviews = parseReviews(response)
  var averrage = 0
  var sum = 0

  for (var i = 0; i < reviews.length; i++) {
    sum += reviews[i].rating
  }

  averrage = sum / reviews.length

  return averrage
}

export function getProductReviews (productId) {
  return new Promise((resolve, reject) => {
    axios.get(`${config.reviewsCacheUrl}/${productId}`)
      .then(response => {
        resolve({
          rating: getReviewsAverrage(response),
          reviews: parseReviews(response),
          reviewsCount: parseReviews(response).length
        })
      })
      .catch(reject)
  })
}



// WEBPACK FOOTER //
// ./src/api/productReviews/getProductReviews.js